// Service Worker Registration for PWA

export function register() {
  if ('serviceWorker' in navigator) {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    const doRegister = () => {
      navigator.serviceWorker
        .register(swUrl, { scope: `${process.env.PUBLIC_URL}/` })
        .then(registration => {
          console.log('[SW] Registration successful:', registration.scope);

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('[SW] Update found, installing...');

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[SW] New version available');
              }
            });
          });
        })
        .catch(error => {
          console.error('[SW] Registration failed:', error);
        });
    };

    if (document.readyState === 'complete') {
      doRegister();
    } else {
      window.addEventListener('load', doRegister);
    }
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error('[SW] Unregister failed:', error);
      });
  }
}
